import Vue from 'vue'
import Router from 'vue-router'

let routes = []
const context = require.context('./modules', false, /\.js$/)
const keys = context.keys()
keys.map(routerPath => {
    const value = context(routerPath).default
    routes = routes.concat(value)
})
routes.push({
    path: '*',
    name: '404',
    meta: {
        title: '文化旅游云'
    },
    component: resolve => require([`@/pages/not-find/not-find.vue`], resolve)
})

Vue.use(Router)
export default new Router({
    routes
})
